import { css } from 'linaria';
import { breakpoints } from 'common/styles/breakpoints';

export const image = css`
  position: fixed;
  top: 50%;
  left: 0;
  right: 0;
  bottom: 50%;
  width: 100%;
  max-width: 100%;
  height: auto;
  max-height: 100%;
  padding: var(--space-1000);
  margin: auto;
  overflow: auto;
  object-fit: contain;

  ${breakpoints.only.tablet} {
    padding: var(--space-500);
  }
  ${breakpoints.to.tablet} {
    padding: var(--space-200);
  }
`;
